import React, {createContext, useContext, useMemo, ReactNode} from 'react';
import {
  isAndroid,
  isIOS,
  osName,
  osVersion,
  mobileModel,
} from 'react-device-detect';
import {FormType} from '@/components/help/common/FormContainer/types';

interface FormContextValue {
  isAndroid: boolean;
  isIOS: boolean;
  osName: string;
  osVersion: string;
  mobileModel: string;
  type: FormType;
}

const FormContainerContext = createContext<FormContextValue | undefined>(
  undefined,
);

export const useFormContainerContext = () => {
  const context = useContext(FormContainerContext);
  if (!context) {
    throw new Error(
      '이 컴포넌트는 FormContainerProvider 내부에서 사용해야 합니다.',
    );
  }
  return context;
};

export const FormContainerProvider = ({
  children,
  type,
}: {
  children: ReactNode;
  type: FormType;
}) => {
  const value = useMemo(
    () => ({
      isAndroid,
      isIOS,
      osName,
      osVersion,
      mobileModel,
      type,
    }),
    [type],
  );

  return (
    <FormContainerContext.Provider value={value}>
      {children}
    </FormContainerContext.Provider>
  );
};
